var map = {
	"./_MG_0715.jpg": 32389,
	"./_MG_0761.jpg": 7539,
	"./_MG_0772.jpg": 66396,
	"./_MG_0775.jpg": 81279,
	"./_MG_0786.jpg": 36014,
	"./_MG_0798.jpg": 17277,
	"./_MG_0800.jpg": 28349,
	"./_MG_0810.jpg": 85250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18738;